<template>
  <card-info-component
    :title="$t('pages.permission.vacations.days_for_confirm')"
    :value="value"
  ></card-info-component>
</template>

<script>
import { CardInfoComponent } from "@/pages/components";

export default {
  name: "DaysWaitingForConfirmWidget",
  components: {
    CardInfoComponent,
  },
  data() {
    return {
      value: 0,
    };
  },
};
</script>

<style scoped></style>
